<div>
  <div class="dialog-header">
    <h4 mat-dialog-title>Layer integration</h4>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="layerIntegrationForm">
    <mat-dialog-content>
      <mat-form-field floatLabel="always">
        <mat-label>Repository Name</mat-label>
        <input matInput [placeholder]="data.repoName" readonly />
        <mat-hint>Repository name for layer integration.</mat-hint>
      </mat-form-field>
      <hr />
      @if (data.layerType == 'Raster') {
        <div class="geom-table-names-div">
          <mat-label><strong> Admin Geom Table Names </strong></mat-label>
          <mat-selection-list formControlName="adminGeomTableName">
            @for (geomTableName of data.adminGeomTableNames; track geomTableName) {
              <mat-list-option [value]="geomTableName">{{ geomTableName }}</mat-list-option>
            }
          </mat-selection-list>
          <mat-hint>Select one or more scale levels.</mat-hint>
        </div>
        <hr />
      }

      <mat-form-field class="description-field">
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" placeholder="Enter layer description" />
        <mat-hint>Brief description of the layer</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Style</mat-label>
        <input matInput formControlName="style" placeholder="Enter style name" />
        <mat-hint>Name of the style in the GeoServer</mat-hint>
      </mat-form-field>
    </mat-dialog-content>
  </form>
  <mat-dialog-actions>
    @if (isLoading$()) {
      <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
    }
    <button
      matButton="filled"
      (click)="submitFormLayerIntegration()"
      [disabled]="layerIntegrationForm.invalid || isLoading$()"
    >
      Integrate
    </button>
  </mat-dialog-actions>
</div>
